module.exports = __webpack_public_path__ + "static/media/wastewijzer_logo.ac2818c4.png";